export default __webpack_public_path__ + "static/media/genesis.f6bee4e6.png";